export default {
  _default: `El valor es inválido`,
  alpha_dash: `El campo solo debe contener letras, números y guiones.`,
  alpha_num: `El campo solo debe contener letras y números.`,
  alpha_spaces: `El campo solo debe contener letras y espacios.`,
  alpha: `El campo solo debe contener letras.`,
  between: `El campo debe estar entre {min} y {max}.`,
  confirmed: `El campo no coincide con {confirmedField}.`,
  credit_card: `El campo es inválido.`,
  date_between: `El campo debe estar entre {min} y {max}.`,
  date_format: `El campo debe tener formato formato {format}.`,
  decimal: `El campo debe ser númerico y contener {decimals} puntos decimales.`,
  digits: `El campo debe ser númerico y contener exactamente {length} dígitos.`,
  dimensions: `El campo debe ser de {width} pixeles por {height} pixeles.`,
  email: `El campo debe ser un correo electrónico válido.`,
  ext: `El campo debe ser un archivo válido.`,
  image: `El campo debe ser una imagen.`,
  in: `El campo debe ser un valor válido.`,
  ip: `El campo debe ser una dirección ip válida.`,
  max: `El campo no debe ser mayor a {length} caracteres.`,
  max_value: `El campo debe de ser {length} o menor.`,
  mimes: `El campo debe ser un tipo de archivo válido.`,
  min: `El campo debe tener al menos {length} caracteres.`,
  min_value: `El campo debe ser {length} o superior.`,
  not_in: `El campo debe ser un valor válido.`,
  numeric: `El campo debe contener solo caracteres númericos.`,
  regex: `El formato del campo no es válido.`,
  required: `El campo es obligatorio.`,
  size: `El campo debe ser menor a {size} KB.`,
  url: `El campo no es una URL válida.`
};



// WEBPACK FOOTER //
// ./src/common/lang/es/validates.js